import styled from 'styled-components';

export const Title = styled.h2`
  padding: 0 16px;
`;
